import axios from 'axios'
import { useAuthStore } from '../store/auth'

/**
 * Instância Axios configurada para a API do ChurchTech Backend.
 * A URL base é definida pela variável de ambiente `VITE_API_URL` (ex: Railway),
 * com fallback para localhost na dev.
 */
// Em dev (sem VITE_API_URL) usa o proxy Vite (/api → localhost:3000).
// Em produção usa a URL absoluta do Railway via VITE_API_URL.
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? '/api',
  timeout: 15_000,
})

// Lê o token do store Zustand (não do localStorage diretamente) para consistência
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Só faz logout em 401 — e apenas se não for a rota de login (evita loop de redirect)
    if (err.response?.status === 401 && !err.config?.url?.includes('/auth/login')) {
      useAuthStore.getState().logout()
      // O AppLayout detecta token null e redireciona via <Navigate to="/login">
    }
    return Promise.reject(err)
  }
)

export default api
